<template>
     <div class="tenantagreement-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Tenant's Contract/Agreement" 
                />
    <b-card class="tenantagreement-search-card">
        <b-tabs card >
            <b-tab title="Registration" active>
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="tenantagreement-id" 
                type="hidden" 
                v-model="tenantagreement.id" />
             <b-row>
             
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Agreement Date:"
                    label-for="tenantagreement-agreement_date"
                    >
                    <b-form-input
                    id="tenantagreement-agreement_date"
                    type="date"
                    v-model="tenantagreement.agreement_date"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Closing Date:"
                    label-for="tenantagreement-closing_date_agreement"
                    >
                    <b-form-input
                    id="tenantagreement-closing_date_agreement"
                    type="date"
                    v-model="tenantagreement.closing_date_agreement"
                    :disabled="true"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Canceled Date:"
                    label-for="tenantagreement-canceled_date_agreement"
                    >
                    <b-form-input
                    id="tenantagreement-canceled_date_agreement"
                    type="date"
                    v-model="tenantagreement.canceled_date_agreement"
                    :disabled="true"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreement.exist_contract_agreement" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreement-exist_contract_agreement"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" 
                                for="tenantagreement-exist_contract_agreement">
                                Contract?
                            </label>
                        </div>
                    </div>
                </b-col> 
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreement.unified_contract_agreement" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreement-unified_contract_agreement"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" 
                                for="tenantagreement-unified_contract_agreement">
                                Unified contract?
                            </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>
             <b-row>
                  <b-col md="6" sm="12">
                    <b-form-group 
                        label="Landlord:" 
                        label-for="tenantagreement-ower_id_agreement">
                        <b-select 
                            id="tenantagreement-ower_id_agreement"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="owners" 
                            @input="loadOwnerImmobiles(tenantagreement.ower_id_agreement)"
                            v-model="tenantagreement.ower_id_agreement" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Property:" 
                        label-for="tenantagreement-ower_contract_item_id_agreement">
                        <b-select 
                            id="tenantagreement-ower_contract_item_id_agreement"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobiles" 
                            @input="loadOwnerImmobileItems(tenantagreement.ower_immobile_id_agreement)"
                            v-model="tenantagreement.ower_immobile_id_agreement" 
                            />
                    </b-form-group>
                </b-col> 
                <b-col md="6" sm="12" v-show="tenantagreement.unified_contract_agreement == 0 || tenantagreement.unified_contract_agreement == null">
                    <b-form-group 
                        label="Location:" 
                        label-for="tenantagreement-immobilie_item_id_agreement">
                        <b-select 
                            id="tenantagreement-immobilie_item_id_agreement"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobile_items" 
                            v-model="tenantagreement.immobilie_item_id_agreement" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Tenant:" 
                        label-for="tenantagreement-tenant_id_agreement">
                        <b-select 
                            id="tenantagreement-tenant_id_agreement"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="tenants" 
                            v-model="tenantagreement.tenant_id_agreement" 
                            />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Agreement Months:"
                        label-for="tenantagreement-contract_months_agreement"
                        >
                        <b-form-input
                            id="tenantagreement-contract_months_agreement"
                            v-model="tenantagreement.contract_months_agreement"
                            type="number"
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Value Agreement:"
                        label-for="tenantagreement-contract_value_agreement"
                    >
                        <b-form-input
                            id="tenantagreement-contract_value_agreement"
                            type="number"
                            v-model="tenantagreement.contract_value_agreement"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                             :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Deposit Amount:"
                        label-for="tenantagreement-deposit_amount_agreement"
                    >
                        <b-form-input
                            id="tenantagreement-deposit_amount_agreement"
                            type="number"
                            v-model="tenantagreement.deposit_amount_agreement"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                             :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row>
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Cleaning fee:"
                        label-for="tenantagreement-cleaning_fee_value"
                    >
                        <b-form-input
                            id="tenantagreement-cleaning_fee_value"
                            type="number"
                            v-model="tenantagreement.cleaning_fee_value"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                             :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreement.account_included_agreement" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreement-account_included_agreement"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" 
                                for="tenantagreement-account_included_agreement">
                                Accounts Included?
                            </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreement.garage_included_agreement" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreement-garage_included_agreement"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" 
                                for="tenantagreement-garage_included_agreement">
                                Garage Included?
                            </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="6" sm="12">
                     <b-form-radio-group
                        v-model="tenantagreement.payment_form_agreement"
                        :options="optionsPayment"
                        class="mb-3"
                        value-field="item"
                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        text-field="name"
                        ></b-form-radio-group>
                    </b-col>
             </b-row>
             
            <b-card class="tenantagreement-search-card">
                    <b-tabs card vertical >
                        <b-tab title="Financial Detail" active>
                        <b-form>
                        <b-row>
                            <b-button  
                                size="sm" 
                                variant="light" 
                                title="Add"
                                class="mt-2  mb-2 fa fa-plus" 
                                @click="openModalFinancial">
                            </b-button>
                        </b-row>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            :per-page="perPage" 
                            :current-page="currentPageFinancial" 
                            head-variant="light" 
                            :items="tenantagreementfinancialdetails" 
                            :fields="fielsFinancial">
                              <template v-slot:cell(actions)="data">
                                <b-button  
                                    title = "Report payment" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[loadFinancial(data.item),openModalFinancial()]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                                 <b-button 
                                    title="Delete" 
                                    size="sm" 
                                    variant="light" 
                                    @click="showMsgBoxDeleteFinancial(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-trash"></i>
                                </b-button>
                                 <b-button 
                                    title="Payment Receipt" 
                                    size="sm" 
                                    variant="light" 
                                    v-if="data.item.form_payment_financial_detail > 0"
                                    @click="[printerPaymentReceipt(data.item)]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                              </template>
                     
                        </b-table>
                        </transition>   
                        <b-pagination
                           v-show="showTable"
                            v-model="currentPageFinancial"
                            :total-rows="rowsFinancial"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>                          
                            </b-row>
                        </b-form>

                        </b-tab >
                         <b-tab title="Responsible" >
                              <b-form>
                        <b-row>
                            <b-button  
                                size="sm" 
                                variant="light" 
                                title="Add"
                                class="mt-2  mb-2 fa fa-plus" 
                                @click="openModalResponsible">
                            </b-button>
                        </b-row>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="tenantagreementresponsibles" 
                            :fields="fieldsResponsible">
                              <template v-slot:cell(actions)="data">
                                <b-button 
                                    title="Edit" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[loadTenantResponsible(data.item),openModalResponsible()]" class="mr-2 mt-2">
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button 
                                    title="Delete" 
                                    size="sm" 
                                    variant="light" 
                                    @click="showMsgBoxDeleteResponsible(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-trash"></i>
                                </b-button>
                              </template>
                     
                        </b-table>
                        </transition>   
                                             
                            </b-row>
                        </b-form>
                         </b-tab>
                    </b-tabs>
                   
                    
                </b-card>
        <br>
         </b-form>
            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
             <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="9" sm="12">
                             <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by tenant name / Address" 
                            class="form-control">
                    </div>
                     </b-col>
                   
             </b-row>
              <b-row v-show="mode !== 'save' && mode !== 'remove'">
                     <b-col md="2" sm="12">
                        <b-form-group
                            label="Months to end:"
                            label-for="tenantagreement-months_end"
                            >
                            <b-form-input
                                id="tenantagreement-months_end"
                                v-model="months_end"
                                @input="loadOwnerContracts"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="3" sm="12">
                         <b-form-group 
                                label="Current Contracts:">
                            <b-form-radio-group
                                size="sm"
                                v-model="current_contract"
                                @input="loadOwnerContracts"
                                :options="optionsCurrent"
                                name="orderservice-current_contract"
                            ></b-form-radio-group>  
                            </b-form-group>  
                    </b-col>
              </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">

          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                 <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                <b-dropdown id="dropdown-form-offset" size="sm" text="..." ref="dropdown" variant="outline-info" class="mr-2 mt-2">
                    <b-button 
                        title="Agreement" 
                        size="sm" 
                        variant="light" 
                        @click="[printerAgreement(data.item)]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                    <b-button  
                        v-if="!data.item.approval_date_agreement"
                        title = "Approval" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxApproval(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>    
                     <b-button  
                        v-if="!data.item.closing_date_agreement"
                        title = "Close" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxClosed(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-window-close-o"></i>
                    </b-button> 
                    <b-button  
                        v-if="!data.item.canceled_date_agreement"
                        title = "Cancel" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCanceled(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-ban"></i>
                    </b-button>     
                     <b-dropdown-divider></b-dropdown-divider>
                    <b-button  
                        v-if="data.item.canceled_date_agreement"
                        title = "Letter of Cancellation" 
                        size="sm" 
                        variant="light" 
                        @click="printerCancellationContract(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-file-pdf-o"></i>
                    </b-button>              
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                     <b-dropdown-divider></b-dropdown-divider>
                     <b-button
                        title = "Attachment Signed Document"
                        size="sm"
                        @click="setPassport(data.item)"
                        variant="light"
                        class="mr-2 mt-2 fa fa-plus"
                        v-b-modal.modalFile
                        > 
                    </b-button>
                     <b-button
                        title="View Signed Doc."
                            size="sm"
                            variant="light"
                            v-if="data.item.storege_id_doc_signed_agreement > 0"
                            @click="loadUrl(data.item.url_file)"
                            class="mr-2 mt-2"
                        >
                        <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                </b-dropdown>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
        </b-tab>
         <b-tab title="Receipt Control" >
              <b-form >
                      <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group
                            label="Start Due Date:"
                            label-for="tenantagreementfinancialdetail-start_date"
                            >
                            <b-form-input
                            id="tenantagreementfinancialdetail-start_date"
                            type="date"
                            v-model="start_date"
                            size="sm"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group
                            label="End Due Date:"
                            label-for="tenantagreementfinancialdetail-end_date"
                            >
                            <b-form-input
                            id="tenantagreementfinancialdetail-end_date"
                            type="date"
                            v-model="end_date"
                            size="sm"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Situation">
                            <b-form-radio-group
                                size="lg"
                                v-model="receipt"
                                @input="loadFinancialControls"
                                :options="optionsReceipt"
                                name="orderservice-receipt"
                            ></b-form-radio-group>  
                            </b-form-group>    
                        </b-col>
                         <b-col md="2" sm="12">
                            <b-button 
                                title="Financial Detail" 
                                size="sm" 
                                variant="light" 
                                @click="printerFinancialDetail" 
                                class="ml-2 mr-2 mt-2">
                                <i class="fa fa-file-pdf-o"></i>
                            </b-button> 
                             <b-button 
                                title="Financial Analytical" 
                                size="sm" 
                                variant="light" 
                                @click="printerFinancialDetailComplet" 
                                class="ml-2 mr-2 mt-2">
                                <i class="fa fa-file-pdf-o"></i>
                            </b-button> 
                             <b-button 
                                title="Clear Filters" 
                                size="sm" 
                                variant="light" 
                                @click="eraserFilter" 
                                class="ml-2 mr-2 mt-2">
                                <i class="fa fa-eraser"></i>
                            </b-button> 
                         </b-col>
                      </b-row>
                       <b-row>
                            <b-col md="6" sm="12">
                                <b-form-group
                                    label="Business Unit:"
                                    label-for="business_unit_id_immobile"
                                >
                                    <b-form-select
                                        id="business_unit_id_immobile"
                                        size="sm"
                                        :options="businessunits"
                                        v-model="business_unit_id"
                                    />
                                </b-form-group>
                            </b-col>
                             <b-col md="6" sm="12">
                                <b-form-group 
                                    label="Financial Box:" 
                                    label-for="financial_box_id_financial_detail">
                                    <b-select 
                                        id="financial_box_id_financial_detail"
                                        size="sm"
                                        :options="financialboxs" 
                                        v-model="financial_box_id" 
                                        />
                                </b-form-group>
                            </b-col> 
                        </b-row>
                          <b-row>
                            <b-col md="6" sm="12">
                                <b-form-group 
                                    label="Landlord:" 
                                    label-for="owner_id">
                                    <b-select 
                                        id="owner_id"
                                        size="sm"
                                        :options="owners" 
                                        @input="loadOwnerImmobiles(owner_id)"
                                        v-model="owner_id" 
                                        />
                                </b-form-group>
                            </b-col> 
                             <b-col md="6" sm="12">
                                <b-form-group 
                                    label="Property:" 
                                    label-for="immobile_id">
                                    <b-select 
                                        id="immobile_id"
                                        size="sm"
                                        :options="immobiles" 
                                        v-model="immobile_id" 
                                        />
                                </b-form-group>
                            </b-col> 
                        </b-row>
                        <b-row>
                            <b-col md="6" sm="12">
                                <b-form-group 
                                    label="Operation:" 
                                    label-for="operation_leve_one_id">
                                    <b-select 
                                        id="operation_leve_one_id"
                                        size="sm"
                                        :options="operationslevelones" 
                                        v-model="operation_leve_one_id" 
                                        />
                                </b-form-group>
                            </b-col> 
                        </b-row>
                 
                      <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                        class="table-responsive" 
                        :per-page="perPage" 
                        :current-page="currentPageFinancialSearch" 
                        hover 
                        head-variant="dark" 
                        :items="financialtenantagreementcontracts" 
                        :fields="fielsFinancialSearch">
                        <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                        </div>
                        </template>
                        <template v-slot:cell(actions)="data">
                                <b-button  
                                    title = "Report payment" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[loadFinancial(data.item),openModalFinancial()]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                                 <b-button 
                                    title="Payment Receipt" 
                                    size="sm" 
                                    variant="light" 
                                    v-if="data.item.form_payment_financial_detail > 0"
                                    @click="[printerPaymentReceipt(data.item)]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>    
                    
                        </template>    
                        </b-table> 
                        </transition>
                        <transition  name="slide" type="animation" appear>
                        <b-pagination
                        v-show="showTable"
                        v-model="currentPage"
                        :total-rows="rowsTenantFinancial"
                        :per-page="perPage"
                        size="sm"
                        aria-controls="my-table"
                        ></b-pagination>
                        </transition>
                      </b-row>
              </b-form>
              
         </b-tab>
         <b-tab title="Property Detail" >
            <b-row>
                 <b-col md="3" sm="12">
                    <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="regbusinessunits" 
                            :fields="fieldsBussinessUnit">
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                    title="View" 
                                    size="sm" 
                                    variant="light" 
                                    @click="loadBussinessImmobiles(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                        </template>
                    </b-table>
                 </b-col>
                  <b-col md="5" sm="12">
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="regimmobiles" 
                            :fields="fieldImmobileBussiness">
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                    title="View" 
                                    size="sm" 
                                    variant="light" 
                                    @click="loadBussinessTenant(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                        </template>
                    </b-table>
                  </b-col>
                  <b-col md="4" sm="12">
                    <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="regtenantagreements" 
                            :fields="fieldsTenantBussiness">
                       
                    </b-table>
                  </b-col>
            </b-row>
         </b-tab>
    </b-tabs>
</b-card>
        <b-modal
            id="modalFinancial"
            ref="modal"
            title-tag="h6"
            title="Financial details"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveFinancial"
        >
            <b-form>
                <b-row>
                     <b-col md="4" sm="12">
                        <b-form-group
                        label="Due Date:"
                        label-for="tenantagreementfinancialdetail-due_date_financial_detail"
                        >
                        <b-form-input
                        id="tenantagreementfinancialdetail-due_date_financial_detail"
                        type="date"
                        v-model="tenantagreementfinancialdetail.due_date_financial_detail"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                        <b-col md="4" sm="12">
                        <b-form-group
                        label="Received Date:"
                        label-for="tenantagreementfinancialdetail-receipt_date_financial_detail"
                        >
                        <b-form-input
                        id="tenantagreementfinancialdetail-receipt_date_financial_detail"
                        type="date"
                        v-model="tenantagreementfinancialdetail.receipt_date_financial_detail"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                      <b-col md="4" sm="12">
                        <b-form-group
                            label="Value:"
                            label-for="tenantagreementfinancialdetail-value_finacial_detail"
                        >
                            <b-form-input
                                id="tenantagreementfinancialdetail-value_finacial_detail"
                                type="number"
                                v-model="tenantagreementfinancialdetail.value_finacial_detail"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                      <b-col md="4" sm="12">
                        <b-form-group
                            label="Amount Received:"
                            label-for="tenantagreementfinancialdetail-value_receipt_detatil"
                        >
                            <b-form-input
                                id="tenantagreementfinancialdetail-value_receipt_detatil"
                                type="number"
                                v-model="tenantagreementfinancialdetail.value_receipt_detatil"
                                size="sm"
                                @input="ItemValue"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Remaining Balance:"
                            label-for="tenantagreementfinancialdetail-value_balance_detail"
                        >
                            <b-form-input
                                id="tenantagreementfinancialdetail-value_balance_detail"
                                type="number"
                                v-model="tenantagreementfinancialdetail.value_balance_detail"
                                size="sm"
                                :readonly="true"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreementfinancialdetail.deposit_financial_detail" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreementfinancialdetail-deposit_financial_detail"
                            >
                            <label class="form-check-label" for="tenantagreementfinancialdetail-deposit_financial_detail">
                                Deposit?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenantagreementfinancialdetail.proportional_financial_detail" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenantagreementfinancialdetail-proportional_financial_detail"
                            >
                            <label class="form-check-label" for="tenantagreementfinancialdetail-proportional_financial_detail">
                                Proporcional?
                            </label>
                        </div>
                    </div>
                </b-col>  
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                     <b-form-radio-group
                        v-model="tenantagreementfinancialdetail.form_payment_financial_detail"
                        :options="optionsPayment"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        ></b-form-radio-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                    <b-form-group 
                        label="Financial Box:" 
                        label-for="tenantagreementfinancialdetail-financial_box_id_financial_detail">
                        <b-select 
                            id="tenantagreementfinancialdetail-financial_box_id_financial_detail"
                            size="sm"
                            :options="financialboxs" 
                            v-model="tenantagreementfinancialdetail.financial_box_id_financial_detail" 
                            />
                    </b-form-group>
                </b-col> 
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Operation:" 
                        label-for="tenantagreementfinancialdetail-operation_leve_one_id_detatil">
                        <b-select 
                            id="tenantagreementfinancialdetail-operation_leve_one_id_detatil"
                            size="sm"
                            :options="operationslevelones" 
                            v-model="tenantagreementfinancialdetail.operation_leve_one_id_detatil" 
                            />
                    </b-form-group>
                </b-col>
                </b-row>

                <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Notes:" 
                            label-for="tenantagreementfinancialdetail-comments_financial_detail">
                        <b-form-textarea id="tenantagreementfinancialdetail-comments_financial_detail"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="tenantagreementfinancialdetail.comments_financial_detail"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>
               
            </b-form>
        </b-modal>
        <b-modal
            id="modalTenantAgreementResponsible"
            ref="modal"
            title-tag="h6"
            title="Responsible"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveResponsible"
        >
            <b-row>
                <b-col md="12" sm="12">
                    <b-form-group 
                        label="Tenant:" 
                        label-for="tenantagreementresponsible-tenant_id_responsible">
                        <b-select 
                            id="tenantagreementresponsible-tenant_id_responsible"
                            size="sm"
                            @input="loadTenant(tenantagreementresponsible.tenant_id_responsible)"
                            :options="tenants" 
                            v-model="tenantagreementresponsible.tenant_id_responsible" 
                            />
                    </b-form-group>
                </b-col>
            </b-row>
             <b-row>
                <b-col md="12" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="tenantagreementresponsible-name_responsible">
                        <b-form-input 
                            id="tenantagreementresponsible-name_responsible" 
                            type="text" 
                            v-model="tenantagreementresponsible.name_responsible" 
                            required
                            size="sm"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                 <b-col md="5" sm="12">
                    <b-form-group 
                        label="Nationality:" 
                        label-for="tenantagreementresponsible-nationality_responsable">
                        <b-form-input 
                            id="tenantagreementresponsible-nationality_responsable" 
                            type="text"
                            v-model="tenantagreementresponsible.nationality_responsable" 
                                size="sm"
                            placeholder="Nationality" />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Passport:" 
                        label-for="tenantagreementresponsible-passport_responsible">
                        <b-form-input 
                            id="tenantagreementresponsible-passport_responsible" 
                            type="text"
                            v-model="tenantagreementresponsible.passport_responsible" 
                            size="sm"
                            placeholder="Passport" />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="E-mail:" 
                        label-for="tenantagreementresponsible-email_responsible">
                        <b-form-input 
                        id="tenantagreementresponsible-email_responsible" 
                        type="email"
                        v-model="tenantagreementresponsible.email_responsible" 
                        size="sm"
                        placeholder="E-mail" />
                    </b-form-group>
                 </b-col>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Phone number:" 
                        label-for="tenantagreementresponsible-cellphone_responsible">
                        <b-form-input 
                            id="tenantagreementresponsible-cellphone_responsible" 
                            type="text"
                            v-model="tenantagreementresponsible.cellphone_responsible" 
                            size="sm"
                            placeholder="Phone number" />
                    </b-form-group>
                </b-col>
             </b-row>
        </b-modal>
         <b-modal
            id="modalImmobile"
            ref="modal"
            title-tag="h6"
            title="Property"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobile"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Location:"
                            label-for="tenantagreementitem-immobile_item_id_contract_item"
                        >
                            <b-form-select
                                id="tenantagreementitem-immobile_item_id_contract_item"
                                size="sm"
                                :options="typeimmobiles"
                                v-model="tenantagreementitem.immobile_item_id_contract_item"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Value Payment:"
                            label-for="tenantagreementitem-value_payment_contract_item"
                        >
                            <b-form-input
                                id="tenantagreementitem-value_payment_contract_item"
                                type="number"
                                v-model="tenantagreementitem.value_payment_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Value Receive:"
                            label-for="tenantagreementitem-value_receive_contract_item"
                        >
                            <b-form-input
                                id="tenantagreementitem-value_receive_contract_item"
                                type="number"
                                v-model="tenantagreementitem.value_receive_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
          </b-form>
        </b-modal>
          <b-modal
            id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>      
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'TenantAgreementSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                months_end: null,
                current_contract:1,
                file: null,
                tenantagreement: {},
                tenantagreementresponsible: {},
                tenantagreementitem: {},
                immobile: {},
                tenants:[],
                businessunits:[],
                tenantagreementfinancialdetail:{},
                tenantagreementfinancialdetails:[],
                tenantagreementresponsibles:[],
                financialboxs:[],
                owners:[],
                immobiles:[],
                immobile_items:[],
                tenantagreements: [],
                typeimmobiles: [],
                tenantagreementcontracts:[],
                financialtenantagreementcontracts:[],
                operationslevelones: [],
                perPage: 20,
                currentPage: 1,
                currentPageFinancial: 1,
                currentPageFinancialSearch: 1,
                isBusy: false,
                showTable: false,
                start_date: null,
                end_date: null,
                receipt: null,
                business_unit_id: null,
                financial_box_id: null,
                owner_id: null,
                immobile_id: null,
                operation_leve_one_id: null,
                businessunit: {},
                regbusinessunits: [],
                regimmobiles:[],
                regtenantagreements: [],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {
                        key: 'agreement_date',label: 'Agreement Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                     {
                        key: 'closing_date_agreement',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_tenant', label: 'Tenant Name', sortable: false ,variant: 'light'},
                    { key: 'name_owner', label: 'Owner Name', sortable: false ,variant: 'light'},
                    { key: 'address_immobile', label: 'Address', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'number_control_item', label: 'Nº Location', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile_sub', label: 'Sub Location', sortable: false ,variant: 'light'},
                    { key: 'number_control_item_sub', label: 'Nº Sub Location', sortable: false ,variant: 'light'},
                    { key: 'contract_value_agreement', label: 'Value Agreement', sortable: true ,variant: 'light'},
                    { key: 'deposit_amount_agreement', label: 'Deposit Amount', sortable: true ,variant: 'light'},
                    { key: 'cleaning_fee_value', label: 'Cleaning Fee', sortable: true ,variant: 'light'},
                    { key: 'contract_months_agreement', label: 'Agreement Months', sortable: false,variant: 'light'},
                     {
                        key: 'approval_date_agreement',label: 'Approval Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                    }, 
                    {
                        key: 'date_end_agreement',label: 'End Contract ',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },              
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldsResponsible: [
                    { key: 'name_responsible', label: 'Name', sortable: true,variant: 'light' },
                    { key: 'nationality_responsable', label: 'Nationality', sortable: false ,variant: 'light'},   
                    { key: 'email_responsible', label: 'E-mail', sortable: false ,variant: 'light'},   
                    { key: 'cellphone_responsible', label: 'Phone Number', sortable: false ,variant: 'light'},               
                    { key: 'passport_responsible', label: 'Passport', sortable: false ,variant: 'light'},               
                    { key: 'actions', label: 'Action',variant: 'light' },
                ],
                fielsFinancial:[
                    {
                        key: 'due_date_financial_detail',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_finacial_detail', label: 'Value', sortable: false },
                    { key: 'value_receipt_detatil', label: 'Amount Received', sortable: false },
                     {
                        key: 'receipt_date_financial_detail',label: 'Received Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    {
                        key: 'form_payment_financial_detail',
                        label: 'Form of Payment',
                        sortable: true,
                        variant: 'light',
                        formatter: value => (value ? this.returnOptionFinancial(value) : '')
                    },
                    { key: 'deposit_financial_detail', label: 'Deposit', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'}, 
                    { key: 'proportional_financial_detail', label: 'Proportional', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},  
                    { key: 'financial_box_name', label: 'Receipt Local', sortable: false },    
                    { key: 'name_operation_level_one', label: 'Operation', sortable: false },    
                           
                    { key: 'comments_financial_detail', label: 'Notes', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
                fielsFinancialSearch:[
                    { key: 'name_tenant', label: 'Tenant', sortable: false },
                    {
                    key: 'due_date_financial_detail',label: 'Due Date',sortable: true,
                        formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_finacial_detail', label: 'Value', sortable: false },
                     { key: 'value_receipt_detatil', label: 'Amount Received', sortable: false },
                    {
                    key: 'receipt_date_financial_detail',label: 'Received Date',sortable: true,
                        formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_operation_level_one', label: 'Operation', sortable: false },
                    { key: 'form_payment', label: 'Payment Form', sortable: false },
                    { key: 'business_unit_name', label: 'Business Unit', sortable: false },
                    { key: 'financial_box_name', label: 'Financial Box', sortable: false },
                    { key: 'address_immobile', label: 'Property', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
                optionsCurrent: [
                    { item: 1, name: 'Current' },
                    { item: 0, name: 'All' }
                ],
                 optionsPayment: [
                    { item: 1, name: 'Cash' },
                    { item: 2, name: 'Bank Transfer' },
                    { item: 3, name: 'Cash/Bank Transfer' },
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
                fieldsBussinessUnit: [
                        { key: 'business_unit_name', label: 'Description', sortable: true },
                        { key: 'quantity_immobiles', label: 'Property', sortable: true },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                ],
                fieldImmobileBussiness:[
                    { key: 'address_immobile', label: 'Address', sortable: true },
                    { key: 'region_immobile', label: 'Eircode', sortable: true },
                    { key: 'name_owner', label: 'Landlord', sortable: true },
                    { key: 'day_for_payment_contract', label: 'Payment Day', sortable: true },
                    { key: 'day_for_receive_contract', label: 'Receive Day', sortable: true },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                
                ],
                fieldsTenantBussiness: [
                    {
                     key: 'agreement_date',label: 'Agreement',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_tenant', label: 'Tenant Name', sortable: false ,variant: 'light'},
                    { key: 'contract_months_agreement', label: 'Agreement Months', sortable: false,variant: 'light'},
                    {
                        key: 'date_end_agreement',label: 'End Contract ',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                    }
                ],
            }
        },
        computed: {
            filteredList() {
                return this.tenantagreements.filter(tenantagreement => {
                    return tenantagreement.name_tenant.toLowerCase().includes(this.search.toLowerCase())
                        || tenantagreement.address_immobile.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.tenantagreements.length
            },
            rowsFinancial() {
                return this.tenantagreementfinancialdetails.length
            },
            rowsTenantFinancial() {
                return this.financialtenantagreementcontracts.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            returnOptionFinancial(value) {

                   let descrition_task = ''

                    if(value ===1)
                    {
                        descrition_task = 'Cash'
                    }
                    else if(value === 2)
                    {
                        descrition_task = 'Bank Transfer'
                    }else if(value === 3)
                    {
                        descrition_task = 'Cash/Bank Transfer'
                    }


                return descrition_task
            },
            async showMsgBoxApproval(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to approval the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to cancel the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.canceled(item)
                    }
                })
            },
            async showMsgBoxClosed(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to close the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.closed(item)
                    }
                })
            },
            async showMsgBoxDeleteResponsible(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeResponsible(item)
                    }
                })
            },
            async showMsgBoxDeleteFinancial(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeFinancial(item)
                    }
                })
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/tenantagreementsbycompany/${this.compan.id}/?months_end=${this.months_end}&current=${this.current_contract}`
                axios(url).then(res =>{
                     this.tenantagreements = res.data
                      this.isBusy = false
                })
            },
            loadTenant(id){
                 const url = `${baseApiUrl}/tenants/${id}`
                axios(url).then(res =>{

                     this.tenantagreementresponsible = {
                        tenant_agreement_id_resposible: this.tenantagreement.id,
                        tenant_id_responsible: id,
                        name_responsible: res.data.name_tenant,
                        email_responsible: res.data.email_tenant,
                        cellphone_responsible: res.data.cellphone_tenant,
                        passport_responsible: res.data.passport_tenant,
                        nationality_responsable: res.data.nationality_tenant

                      
                     }
                })
            },
            ItemValue() {
                      
                       return( 
                                this.tenantagreementfinancialdetail.value_balance_detail = 
                                (this.tenantagreementfinancialdetail.value_finacial_detail > 0 ? parseFloat(this.tenantagreementfinancialdetail.value_finacial_detail):0) 
                                -
                                (
                                    this.tenantagreementfinancialdetail.value_receipt_detatil > 0 ? parseFloat(this.tenantagreementfinancialdetail.value_receipt_detatil): 0
                                )

                                )

                    },
            alterModo() {
                    this.mode = 'save'
                    this.tenantagreement = {}
                    this.tenantagreementitem = {}
                    this.tenantagreementfinancialdetails = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.tenantagreement = {}
            },
            openModalFinancial() {
                this.$bvModal.show('modalFinancial')
            },
            async save() {

                const method = this.tenantagreement.id ? 'put' : 'post'
                const id = this.tenantagreement.id ? `/${this.tenantagreement.id}` : ''

                if(this.tenantagreement.id){
                    this.tenantagreement.update_date_agreement = this.formatDateTime(Date())
                    this.tenantagreement.update_user_agreement = this.user.id
                }else{
                    this.tenantagreement.user_id_agreement = this.user.id
                }

                this.tenantagreement.tenant_id_agreement = 
                await axios[method](`${baseApiUrl}/tenantagreements${id}`, this.tenantagreement)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            async saveImmobile() {

                    if (this.immobile.id) {
                        this.immobile.update_user_immobile = this.user.id
                        this.immobile.update_date_immobile = this.formatDateTime(Date())
                    } else {
                        this.immobile.user_id_immobile = this.user.id
                    }

                    const method = this.immobile.id ? 'put' : 'post'
                    const id = this.immobile.id ? `/${this.immobile.id}` : ''
                    this.immobile.tenantagreement_id_immobile = this.tenantagreement.id
                    await axios[method](
                        `${baseApiUrl}/immobiles${id}`,
                        this.immobile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobile = {}
                            this.loadOwnerImmobiles()
                        })
                        .catch(showError)
            },
            async saveResponsible() {

                    this.tenantagreementresponsible.user_id_responsable = this.user.id
                    
                    const method = this.tenantagreementresponsible.id ? 'put' : 'post'
                    const id = this.tenantagreementresponsible.id ? `/${this.tenantagreementresponsible.id}` : ''
                    this.tenantagreementresponsible.tenant_agreement_id_resposible = this.tenantagreement.id
                    await axios[method](
                        `${baseApiUrl}/tenantagreementresponsibles${id}`,
                        this.tenantagreementresponsible
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.tenantagreementresponsible = {}
                            this.loadTenantResponsibles()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.tenantagreement.id
                    axios.delete(`${baseApiUrl}/tenantagreements/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeImmobile(item) {
                    axios.delete(`${baseApiUrl}/immobiles/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerImmobiles()
                        })
                        .catch(showError)
            },
            async removeResponsible(item) {
                    axios.delete(`${baseApiUrl}/tenantagreementresponsibles/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTenantResponsibles()
                        })
                        .catch(showError)
            },
            setPassport(tenantagreement){
                this.tenantagreement = { ...tenantagreement }
            },
            async removeFinancial(item) {
                    axios.delete(`${baseApiUrl}/tenantagreementfinancialdetail/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadFinancialDetail()
                        })
                        .catch(showError)
            },
            loadOwner(tenantagreement, mode = 'save') {
                this.mode = mode
                 if(tenantagreement.agreement_date) tenantagreement.agreement_date = this.formatDate(tenantagreement.agreement_date)
                 if(tenantagreement.canceled_date_agreement) tenantagreement.canceled_date_agreement = this.formatDate(tenantagreement.canceled_date_agreement)
                 if(tenantagreement.closing_date_agreement) tenantagreement.closing_date_agreement = this.formatDate(tenantagreement.closing_date_agreement)

                this.tenantagreement = { ...tenantagreement }
                this.loadFinancialDetail()
                this.loadOwnerImmobiles()
                this.loadTenantResponsibles()
                
            },
            loadOwnerImmobile(item){
                this.immobile = {...item}
            },
            loadTenantResponsible(item){
                this.loadTenantResponsible = {...item}
            },
            loadFinancial(item){

                 if(item.due_date_financial_detail) item.due_date_financial_detail = this.formatDate(item.due_date_financial_detail)
                 if(item.receipt_date_financial_detail) item.receipt_date_financial_detail = this.formatDate(item.receipt_date_financial_detail)
                this.tenantagreementfinancialdetail = {...item}
            },
            loadImobile(item){
                const url = `${baseApiUrl}/ownercontractitems/${item}`
                axios.get(url).then(res => {
                    this.immobile = {...res.data}
                     this.tenantagreement = {
                    ...this.tenantagreement,
                    contract_value_agreement: res.data.value_payment_contract_item
                }
                    
                })
            },
             openModalImmobile() {
                this.$bvModal.show('modalImmobile')
            },
            openModalResponsible() {
                this.$bvModal.show('modalTenantAgreementResponsible')
            },
            loadOwners() {
                const url = `${baseApiUrl}/ownersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.owners = res.data.map(type => {
                        return { value: type.id, text: type.name_owner }
                    })
                })
            },
            loadOwnerImmobiles(){
                const url = `${baseApiUrl}/ownercontractsbyowner/${this.tenantagreement.ower_id_agreement?this.tenantagreement.ower_id_agreement:this.owner_id}`
                axios(url).then(res =>{
                     this.immobiles = res.data.map(imobile =>{
                        return {value: imobile.immobile_id_contract , text: imobile.address_immobile + ' / ' + imobile.region_immobile + ' - ' + imobile.name_owner}
                     })
                })
                this.immobile_items = []
            },
            loadOwnerImmobileItems(){
                const url = `${baseApiUrl}/immobileitemsbyidimmobileallocatable/${this.tenantagreement.ower_immobile_id_agreement}`
                axios(url).then(res =>{
                     this.immobile_items = res.data.map(imobile =>{
                        return {value: imobile.id, text: imobile.name_type_part_immobile + ' Nº ' + imobile.number_control_item + ' / ' + imobile.name_type_part_immobile_sub  + ' Nº ' + imobile.number_control_item_sub +  ' - ' + imobile.status}
                     })
                })
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/tenantagreementfinancialdetailbytenant/${this.tenantagreement.id}`
                axios(url).then(res =>{
                     this.tenantagreementfinancialdetails = res.data
                })
            },
            loadTenantResponsibles(){
                const url = `${baseApiUrl}/tenantagreementresponsiblesbytenant/${this.tenantagreement.id}`
                axios(url).then(res =>{
                     this.tenantagreementresponsibles = res.data
                })
            },
            loadTenants() {
                const url = `${baseApiUrl}/tenentsbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.tenants = res.data.map(type => {
                        return { value: type.id, text: type.name_tenant }
                    })
                })
            },
            loadFinancialBoxs() {
                const url = `${baseApiUrl}/financialboxbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.financialboxs = res.data.map(type => {
                        return { value: type.id, text: type.financial_box_name }
                    })
                })
            },
           async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/tenantagreementfinancialdetails/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
           async canceled(item){
                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/tenantagreementfinancialdetailcanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)
           },
            async closed(item){
                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/tenantagreementclosing/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)
           },
            async printerPaymentReceipt(item) {
    
            const url = `${baseApiUrl}/tenantpaymentreceiptprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            async printerFinancialDetail() {
    
            const url = `${baseApiUrl}/tenantagreementfinancialdetailprinter/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&business_unit_id=${this.business_unit_id}&financial_box_id=${this.financial_box_id}&payment_id=${this.receipt}&owner_id=${this.owner_id}&immobile_id=${this.immobile_id}&operation_leve_one_id=${this.operation_leve_one_id}`
            await axios.get(url)
            window.open(url)
            
            },
            async printerFinancialDetailComplet() {
    
            const url = `${baseApiUrl}/tenantagreementfinancialdetailcompletprinter/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&business_unit_id=${this.business_unit_id}&financial_box_id=${this.financial_box_id}&payment_id=${this.receipt}&owner_id=${this.owner_id}&immobile_id=${this.immobile_id}&operation_leve_one_id=${this.operation_leve_one_id}`
            await axios.get(url)
            window.open(url)
            
            },
            eraserFilter(){
                  this.start_date = moment()
                .add(-30, "d")
                .format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");
                this.financial_box_id = null
                this.business_unit_id = null
                this.owner_id= null,
                 this.immobile_id= null
                 this.operation_leve_one_id = null
            },
            async printerAgreement(item) {
    
            const url = `${baseApiUrl}/tenantagreementprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            async printerCancellationContract(item) {
    
            const url = `${baseApiUrl}/tenantagreementcancelationcontractprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            async saveFinancial() {

                    if(!this.tenantagreementfinancialdetail.id > 0){
                        this.tenantagreementfinancialdetail.company_id_financial_detail = this.compan.id
                        this.tenantagreementfinancialdetail.tenant_agreement_id_financial_detail = this.tenantagreement.id

                    }
             
                    const method = this.tenantagreementfinancialdetail.id ? 'put' : 'post'
                    const id = this.tenantagreementfinancialdetail.id ? `/${this.tenantagreementfinancialdetail.id}` : ''
                    await axios[method](
                        `${baseApiUrl}/altertenantagreementfinancialdetails${id}`,
                        this.tenantagreementfinancialdetail
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.tenantagreementfinancialdetail = {}
                            this.loadFinancialDetail()
                            this.loadFinancialControls()
                        })
                        .catch(showError)
            },
            loadFinancialControls(){
                const url = `${baseApiUrl}/tenantagreementfinancialsearch/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&receipt=${this.receipt}&business_unit_id=${this.business_unit_id}&financial_box_id=${this.financial_box_id}&owner_id=${this.owner_id}&immobile_id=${this.immobile_id}&operation_leve_one_id=${this.operation_leve_one_id}`
                axios(url).then(res =>{
                     this.financialtenantagreementcontracts = res.data
                })

            },
            loadUrl(item){
                const url = item
                window.open(url)
            },
              async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
                async getLastStorageFile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                    await axios(url).then(
                        (res) =>
                        (this.tenantagreement = {
                            ...this.tenantagreement,
                            storege_id_doc_signed_agreement: res.data.id,
                        })
                    );
                }, 
                loadBusinesss() {
                    const url = `${baseApiUrl}/businessunitbycompany/${this.compan.id}`
                    axios.get(url).then(res => {
                        this.businessunits = res.data.map(type => {
                            return { value: type.id, text: type.business_unit_name }
                        })
                    })
                },
                async loadOperationsLevelOnes() {
                    const url = `${baseApiUrl}/operationslevelones/${2}/?company_id=${this.compan.id}`
                    await axios.get(url).then(res => {
                         this.operationslevelones = res.data.map(type => {
                            return { value: type.id, text: type.name_operation_level_one }
                        })
                      
                    })
                },
                loadBusinesssUnit() {
                    const url = `${baseApiUrl}/businessunitbycompany/${this.compan.id}`
                    axios.get(url).then(res => {
                        this.regbusinessunits = res.data
                        })
                },
                loadBussinessImmobiles(item){
                    const url = `${baseApiUrl}/immobilebybussinessunit/${item.id}`
                    axios(url).then(res =>{
                        this.regimmobiles = res.data
                    })
                },
                loadBussinessTenant(item){
                    const url = `${baseApiUrl}/tenantagreementbytenantimmobile/${item.id}`
                    axios(url).then(res =>{
                        this.regtenantagreements = res.data
                    })
                },

        },
        mounted(){

                this.start_date = moment()
                .add(-30, "d")
                .format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadOwnerContracts()
            this.loadOwners()
            this.loadOwnerImmobiles()
            this.loadTenants()
            this.loadFinancialControls()
            this.loadFinancialBoxs()
            this.loadBusinesss()
            this.loadOperationsLevelOnes()
            this.loadBusinesssUnit()
            this.showTable = true
        }
}
</script>

<style>


    .tenantagreement-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .tenantagreement-search button{
        font-size: 0.75rem;
    }

     .tenantagreement-search select{
        font-size: 0.75rem;
    }

    .tenantagreement-search input{
        font-size: 0.75rem;
    }

    .tenantagreement-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

    

     #modalTenantAgreementResponsible {
        font-size: 0.75rem;
    }

      #modalTenantAgreementResponsible button{
        font-size: 0.75rem;
    }

     #modalTenantAgreementResponsible input{
        font-size: 0.75rem;
    }

     #modalTenantAgreementResponsible label{
        font-size: 0.75rem;
        color: black;
    }

    #modalTenantAgreementResponsible select{
        font-size: 0.75rem;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
